<template>
  <v-container fluid class="pa-4 sac-shared-result">
    <div v-if="loading" class="pa-8 text-center">
      <v-progress-circular indeterminate />
    </div>
    <v-alert v-else-if="error" type="error">{{ error }}</v-alert>
    <div v-else-if="result">
      <h1 class="text-h5 font-weight-bold mb-1">Resultado del Autodiagnóstico SAC</h1>
      <p class="grey--text mb-4">
        {{ memberLabel }}
      </p>

      <v-row>
        <v-col cols="12" md="4">
          <v-card class="pa-4 text-center" outlined>
            <SacIndicatorChart
              :value="Number(result.globalScore || 0)"
              :level="result.globalLevel"
              :color="levelColor"
              height="240px"
            />
            <div class="mt-3 text-body-2 grey--text">
              {{ levelDescription }}
            </div>
          </v-card>
        </v-col>
        <v-col cols="12" md="8">
          <v-card class="pa-4" outlined>
            <h2 class="text-h6 mb-2">Distribución por rubro</h2>
            <SacRadarChart :data="radarData" height="280px" />
          </v-card>
        </v-col>
      </v-row>

      <v-card class="mt-3 pa-4" outlined>
        <h2 class="text-h6 mb-2">Puntaje por sección</h2>
        <SacBarsChart :data="barsData" height="500px" />
      </v-card>

      <v-card v-if="recommendation" class="mt-3 pa-4" outlined>
        <h2 class="text-h6 mb-2">Recomendación</h2>
        <p class="mb-0">{{ recommendation }}</p>
      </v-card>
    </div>
  </v-container>
</template>

<script>
import { getSharedResult } from '../../api/sac';
import SacIndicatorChart from '../../components/sac/SacIndicatorChart.vue';
import SacRadarChart from '../../components/sac/SacRadarChart.vue';
import SacBarsChart from '../../components/sac/SacBarsChart.vue';

export default {
  name: 'SacSharedResult',
  components: { SacIndicatorChart, SacRadarChart, SacBarsChart },
  data() {
    return { loading: true, error: null, result: null };
  },
  computed: {
    memberLabel() {
      const member = this.result?.member;
      const name = member ? `${member.name || ''} ${member.firstLastname || ''}`.trim() : '';
      return name || 'Resultado compartido públicamente';
    },
    levelColor() {
      return this.result?.levelInfo?.color || '#1976D2';
    },
    levelDescription() {
      return this.result?.levelInfo?.description || '';
    },
    recommendation() {
      return this.result?.levelInfo?.recommendation || '';
    },
    radarData() {
      return this.result?.charts?.radar || {};
    },
    barsData() {
      return this.result?.charts?.bars || {};
    },
  },
  async mounted() {
    try {
      this.result = await getSharedResult(this.$route.params.token);
    } catch (error) {
      this.error =
        error?.response?.data?.error?.message ||
        error?.response?.data?.message ||
        error.message ||
        'No se pudo cargar el resultado compartido';
    } finally {
      this.loading = false;
    }
  },
};
</script>
